import React, { useEffect, useState } from "react";
import { Breadcrumb, Button } from "antd";
import { FilterFilled } from "@ant-design/icons";

import {
  Modal,
  Descriptions,
  Table,
  Tag,
  Divider,
  Row,
  Col,
  Avatar,
  ConfigProvider,
} from "antd";

import moment from "moment";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
import "./orders.css";
import OrderDetailModal from "../../components/loader/orderDetails/orderDetails";

const Orders = () => {
  const [isloading, setIsLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getOrderStatusTagProps = (status) => {
    const normalizedStatus = (status || "").toLowerCase();

    if (normalizedStatus === "received" || normalizedStatus === "recived") {
      return {
        color: "#d9f7be",
        style: { color: "#389e0d", borderColor: "#b7eb8f" },
      };
    }

    if (normalizedStatus === "deliver" || normalizedStatus === "delivered") {
      return {
        color: "#fff7cc",
        style: { color: "#ad8b00", borderColor: "#ffe58f" },
      };
    }

    return {};
  };

  const getPaymentStatusTagProps = (paymentStatus) => {
    const normalizedStatus = (paymentStatus || "").toLowerCase();

    if (normalizedStatus === "complete" || normalizedStatus === "completed") {
      return {
        color: "#d9f7be",
        style: { color: "#389e0d", borderColor: "#b7eb8f" },
      };
    }

    if (normalizedStatus === "pending") {
      return {
        color: "#fff7cc",
        style: { color: "#ad8b00", borderColor: "#ffe58f" },
      };
    }

    return {};
  };

  const handleViewOrder = (record) => {
    setSelectedOrder(record);
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const fetchOrders = () => {
    setIsLoading(true);
    callApi(
      "GET",
      `${routes.getAdminOrders}?page=1&limit=50`,
      null,
      setIsLoading,
      (res) => {
        console.log("res", res);
        setOrders(res?.data?.orders || res?.data || []);
      },
      (err) => {
        console.error("error fetching orders", err);
      },
    );
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrderDetails = (orderId) => {
    setIsLoading(true);
    callApi(
      "GET",
      `${routes.getAdminOrderById}/${orderId}`,
      null,
      setIsLoading,
      (res) => {
        console.log("res", res);
        setSelectedOrder(res?.data?.order || res);
        setIsLoading(false);
      },
      (err) => {
        console.error("error fetching order details", err);
        setIsLoading(false);
      },
    );
  };

  const statusFilters = Array.from(
    new Set(
      orders
        .map((order) => order?.status)
        .filter((status) => status !== undefined && status !== null && status !== ""),
    ),
  ).map((status) => ({
    text: status,
    value: status,
  }));

  const columns = [
    {
      title: "Order ID",
      dataIndex: "_id",
      key: "_id",
      render: (orderId) => <Tag color="orange">{orderId || "-"}</Tag>,
    },
    {
      title: "Customer",
      dataIndex: ["customer", "name"],
      key: "customer",
      render: (_, record) => record?.customer?.name || "-",
    },
    {
      title: "Vendor",
      dataIndex: ["vendor", "storeName"],
      key: "vendor",
      render: (_, record) => record?.vendor?.storeName || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: statusFilters,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#ffffff" : "#ffffff" }} />
      ),
      onFilter: (value, record) =>
        (record?.status || "").toLowerCase() === String(value).toLowerCase(),
      render: (status) => (
        <Tag {...getOrderStatusTagProps(status)}>{status || "-"}</Tag>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (paymentStatus) => (
        <Tag {...getPaymentStatusTagProps(paymentStatus)}>
          {paymentStatus || "-"}
        </Tag>
      ),
    },
    { title: "Amount", dataIndex: "totalAmount", key: "totalAmount" },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD MMM YYYY"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleViewOrder(record)}>
          Details
        </Button>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Orders</Breadcrumb.Item>
      </Breadcrumb>
      <div className="page-title">Orders</div>
      <Table
        columns={columns}
        dataSource={orders}
        rowKey="_id"
        pagination={{ pageSize: 10 }}
      />
      <OrderDetailModal
        visible={isModalOpen}
        onClose={handleClose}
        orderData={selectedOrder}
        getOrderStatusTagProps={getOrderStatusTagProps}
        getPaymentStatusTagProps={getPaymentStatusTagProps}
      />
    </div>
  );
};

export default Orders;
